import React, { useState } from 'react';
import { MobileCSContent } from './MobileCSContent';

export const MobileChildSupport = () => {
  const [menuData, setMenuData] = useState([
    { id: 'csArrowBtn1', isOpened: false },
    { id: 'csArrowBtn2', isOpened: false },
    { id: 'csArrowBtn3', isOpened: false },
  ]);

  const [styles, setStyles] = useState({
    firstPackage: {},
    firstArrow: {},
    secondPackage: {},
    secondArrow: {},
    thirdPackage: {},
    thirdArrow: {},
  });

  const packageMenuHandler = e => {
    const result = [];
    let isTimeout = false;
    menuData.forEach((el, idx) => {
      if (el.id === e.target.id) {
        result.push({ id: el.id, isOpened: !el.isOpened });

        if (el.isOpened) {
          isTimeout = true;
          switch (idx) {
            case 0:
              setStyles(curr => ({
                ...curr,
                firstPackage: { animation: 'closePackage 1s forwards' },
                firstArrow: { animation: 'iconRotateUp 1s forwards' },
              }));
              break;
            case 1:
              setStyles(curr => ({
                ...curr,
                secondPackage: { animation: 'closePackage 1s forwards' },
                secondArrow: { animation: 'iconRotateUp 1s forwards' },
              }));
              break;
            case 2:
              setStyles(curr => ({
                ...curr,
                thirdPackage: { animation: 'closePackage 1s forwards' },
                thirdArrow: { animation: 'iconRotateUp 1s forwards' },
              }));
              break;
            default:
              console.error('Wrong package id');
          }
        } else {
          isTimeout = false;
          switch (idx) {
            case 0:
              setStyles(curr => ({
                ...curr,
                firstPackage: { animation: 'openFirstPackage 1s' },
                firstArrow: { animation: 'iconRotateDown 1s forwards' },
              }));
              break;
            case 1:
              setStyles(curr => ({
                ...curr,
                secondPackage: { animation: 'openSecondPackage 1s' },
                secondArrow: { animation: 'iconRotateDown 1s forwards' },
              }));
              break;
            case 2:
              setStyles(curr => ({
                ...curr,
                thirdPackage: { animation: 'openThirdPackage 1s' },
                thirdArrow: { animation: 'iconRotateDown 1s forwards' },
              }));
              break;
            default:
              console.error('Wrong package id');
          }
        }
      } else {
        result.push(menuData[idx]);
      }
    });

    if (isTimeout) {
      setTimeout(() => {
        setMenuData(result);
      }, 1000);
    } else {
      setMenuData(result);
    }
  };

  return (
    <div className="child-support mobile-child-support">
      <div className="child-support-heading mobile-child-support-heading">
        <p>СТЯГНЕННЯ АЛІМЕНТІВ</p>
      </div>
      <div className="mobile-service-packages">
        <div className="mobile-service-package">
          <div
            className="package-arrow-button"
            id={menuData[0].id}
            onClick={packageMenuHandler}
          >
            <i
              className="fas fa-chevron-right arrow-button-icon"
              style={styles.firstArrow}
              id={menuData[0].id}
            ></i>
          </div>
          <div className="mobile-package-info">
            <p className="mobile-package-info-title">ПАКЕТ «МІНІМАЛЬНИЙ»</p>
            {menuData[0].isOpened ? null : (
              <p className="mobile-package-info-price">1000грн</p>
            )}
          </div>
        </div>
        {menuData[0].isOpened ? (
          <MobileCSContent packageName="min" styles={styles.firstPackage} />
        ) : null}
        <div className="mobile-service-package">
          <div
            className="package-arrow-button"
            id={menuData[1].id}
            onClick={packageMenuHandler}
          >
            <i
              className="fas fa-chevron-right arrow-button-icon"
              style={styles.secondArrow}
              id={menuData[1].id}
            ></i>
          </div>
          <div className="mobile-package-info">
            <p className="mobile-package-info-title">ПАКЕТ «ОПТИМАЛЬНИЙ»</p>
            {menuData[1].isOpened ? null : (
              <p className="mobile-package-info-price">2000грн</p>
            )}
          </div>
        </div>
        {menuData[1].isOpened ? (
          <MobileCSContent packageName="mid" styles={styles.secondPackage} />
        ) : null}
        <div className="mobile-service-package">
          <div
            className="package-arrow-button"
            id={menuData[2].id}
            onClick={packageMenuHandler}
          >
            <i
              className="fas fa-chevron-right arrow-button-icon"
              style={styles.thirdArrow}
              id={menuData[2].id}
            ></i>
          </div>
          <div className="mobile-package-info">
            <p className="mobile-package-info-title">
              ПАКЕТ «ПІД КЛЮЧ, БЕЗ ВАШОЇ УЧАСТІ»
            </p>
            {menuData[2].isOpened ? null : (
              <p className="mobile-package-info-price">3500грн</p>
            )}
          </div>
        </div>
        {menuData[2].isOpened ? (
          <MobileCSContent packageName="max" styles={styles.thirdPackage} />
        ) : null}
      </div>
    </div>
  );
};
